(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["l5works-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const selector = '[data-l5works-reveal].l5works-manifesto__text--animated';
    const nodes = document.querySelectorAll(selector);
    if (!nodes.length || !window.IntersectionObserver) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((el) => observer.observe(el));
  })();

  } catch(e) { console.error(e); }
})();
})();
